export class CobpsQuickBookModule {
    constructor() {
        let bookingUrlInput = document.getElementById("cobpsBaseUrl");

        let findButton = document.getElementById("quickBook-find");

        if(!findButton) {
            return;
        }
        
        if(bookingUrlInput != null) {
            this.ApiUrl = bookingUrlInput.value;
            this.checkPmiEnabled();
        }
    }
    
    init() {
        let that = this;
        
        let pmi = document.getElementById("IsPmiEnabledForConsultant");
        if(pmi != null && that.PMIEnabledForConsulant == null) {
            that.PMIEnabledForConsulant = pmi.value === "true";
        }        
        
        let findButton = document.getElementById("quickBook-find");
        
        let consultantId = document.head.querySelector('meta[name="ConsultantId"]').getAttribute("content");
        findButton.addEventListener("click", function () {
            let locationId = document.getElementById("hospitalCode");
            if(locationId != null && locationId.value  !== "") {
                that.getLocations(consultantId, locationId.value);
            } else {
                that.getLocations(consultantId);
            }
            findButton.innerHTML = "Finding next available initial appointment..."
        }, { once: true });
        
        let bookRow = document.getElementById("quickBook-book");
        let insurerSelect = document.getElementById("quickBook-insurers");
        let bookButton = document.getElementById("quickBook-bookButton");
        let cannotBookRow = document.getElementById("quickBook-cannotBook");
        
        let cannotSelfPay = document.getElementById("quickBook-noSelfPay");
        let canSelfPay = document.getElementById("IsSelfPayEnabledForConsultant");
        let selfpayButton = document.getElementById("quickBook-selfpay");
        selfpayButton.addEventListener("click", function () {
            
            insurerSelect.parentElement.classList.add("hidden");
            cannotBookRow.classList.add("hidden");
            insurerSelect.value = "undefined";
            
            if(canSelfPay != null && canSelfPay.value === "true") {
                bookRow.classList.remove("hidden");
                bookButton.classList.remove("hidden");

                cannotSelfPay.classList.add("hidden");
            } else {
                bookRow.classList.add("hidden");
                bookButton.classList.add("hidden");

                cannotSelfPay.classList.remove("hidden");
            }
        });
        
        let insuranceButton = document.getElementById("quickBook-insurance");
        insuranceButton.addEventListener("click", function () {
            cannotSelfPay.classList.add("hidden");
            bookButton.classList.add("hidden");
           if(that.PMIEnabledForConsulant) {
               bookRow.classList.remove("hidden");
               insurerSelect.parentElement.classList.remove("hidden");
           } else {
               insurerSelect.parentElement.classList.add("hidden");
               cannotBookRow.classList.remove("hidden");
           }
        });
        
        let otherInsurerMessage = document.getElementById("quickBook-otherInsurer");        
        insurerSelect.addEventListener("change", function () {
            if(this.value.toLowerCase() === "undefined") {
                bookButton.classList.add("hidden");
            } else if(this.value.toLowerCase() === "other") {
                bookButton.classList.add("hidden");
                otherInsurerMessage.classList.remove("hidden");
            }
            else {
                bookButton.classList.remove("hidden");
                otherInsurerMessage.classList.add("hidden");
            }
        });
        
        bookButton.addEventListener("click", function () { 
            let pm = insuranceButton.checked ? "insurance" : "yourself";
            let i = insurerSelect.value;
            let timeSelected = that.SelectedAppointment.Time;
            let locationName = that.Loaction.Name.toLowerCase();

            window.dataLayer = window.dataLayer || [];
            if (pm === 'yourself') {
                window.dataLayer.push({
                    'event': 'spire_consultant_book',
                    'step': '1',
                    'funding_type': 'self payment',
                    'appointment_type': 'new appointment',
                    'hospital': locationName,
                    'funnel_name': 'consultant search',
                    'time_selected': timeSelected    
                });
            }
            else {
                window.dataLayer.push({
                    'event': 'spire_consultant_book',
                    'step': '1',
                    'funding_type': 'insurance',
                    'insurer_name': i,
                    'appointment_type': 'new appointment',
                    'hospital': locationName,
                    'funnel_name': 'consultant search',
                    'time_selected': timeSelected
                });
            }
            
            let target = `${that.ApiUrl}/?c=${consultantId}&ou=${that.SelectedAppointment.Org}&sd=${that.SelectedAppointment.Date}&d=${that.SelectedAppointment.Duration}&pm=${pm}&i=${i}`;
            
            let windowTarget = document.getElementById("CobpsWindowTarget");
            if(windowTarget != null && windowTarget.value.toLowerCase() === "true") {
                window.open(target, '_blank');
            } else {
                window.location.href = target;
            }
        });
        
        window.addEventListener("unload", function () { 
            insurerSelect.value = "undefined";
            selfpayButton.checked = insuranceButton.checked = false;
        });

        insurerSelect.value = "undefined";
        selfpayButton.checked = insuranceButton.checked = false;
    }
    
    getLocations(consultantId) {
        let that = this;
        
        $.ajax({
            url: this.ApiUrl + "/Umbraco/Api/LocationApi/GetAvailableLocations?locationId=null&consultantId=" + consultantId,
            type: 'GET',
            success: function (data) {
                if(data.length > 0) {
                    let locationId = data[0].LocationId;
                    let name = data[0].Name;
                    that.Loaction = { Name: name, Id: locationId };
                    that.getAppointments(consultantId, locationId);
                } else {
                    that.showNotFound();
                }
            },
            error: function () {
                that.showNotFound();
            }
        })
    }
    
    getAppointments(consultantId, locationId) {
        let that = this;
        let date = new Date();
        let month = date.getMonth() + 1; //JS Months start at 0
        let year = date.getFullYear();
        $.ajax({
            url: this.ApiUrl + "/Umbraco/Api/AppointmentApi/GetFirstAppointmentsForLocation?consultantId=" + consultantId + "&month=" + month + "&year=" + year + "&locationId=" + locationId,
            type: 'GET',
            success: function (data) {
                if(data.length > 0) {
                    let org = data[0].OrganisationUnit;
                    let duration = data[0].Duration;
                    let dateRaw = data[0].SAPDateTime.DateTime;

                    let date = new Date(data[0].SAPDateTime.DateTime);
                    
                    let day = date.toLocaleString('en-GB', { weekday: 'short' });
                    let month = date.toLocaleString('en-GB', { month: 'short' });
                    let time = date.toLocaleString('en-GB', { hour: 'numeric', minute: "numeric" })

                    that.SelectedAppointment = { Date: dateRaw, Org: org, Duration: duration, Time: time };

                    document.getElementById("quickBook-find").classList.add("hidden");
                    document.getElementById("quickBook-resultText").innerHTML = `${day} ${date.getDate()} ${month} - ${time}${date.getHours() > 12 ? 'PM' : 'AM'}`;
                    document.getElementById("quickBook-result").classList.remove("hidden");
                    document.getElementById("quickBook-payment").classList.remove("hidden");
                } else {
                    that.showNotFound();
                }
            },
            error: function () {
                that.showNotFound();
            }
        })
    }
    
    checkPmiEnabled() {
        let that = this;
        $.ajax({
            url: this.ApiUrl + "/Umbraco/Api/PMIApi/CheckPMIEnabled",
            type: 'GET',
            success: function (data) {
                if(data) {
                    that.getPmiList();
                } else {
                    that.showNotFound();
                }
            },
            error: function () {
                that.showNotFound();
            }
        })
    }
    
    getPmiList() {
        let that = this;
        $.ajax( {
            url: this.ApiUrl + "/Umbraco/Api/ContentApi/GetPmiList",
            type: 'GET',
            success: function (data) {
                if(data.length > 0) {
                    let insurerDropdown = document.getElementById("quickBook-insurers");
                    for(let i = 0; i < data.length; i++) {
                        let insurer = data[i];
                        let option = document.createElement("option");
                        option.innerHTML = option.value = insurer.Text;
                        insurerDropdown.appendChild(option);
                    }
                } else {
                    that.PMIEnabledForConsulant = false;
                }
                
                that.init();
            }
        })
    }
    
    showNotFound() {
        let find = document.getElementById("quickBook-find");
        let notFound = document.getElementById("quickBook-notFound");
        
        find.classList.add("hidden");
        notFound.classList.remove("hidden");
    }
}